import './App.css';
import Header from './components/Header/Header';
import Container from './components/Container/Container';

function App() {
  return (
    <div className="banner">
      <Header></Header>
      <Container></Container>
    </div>
  );
}

export default App;
